import { createServiceClient } from "shared/welda/services/axiosClient";

const api = createServiceClient("/users/employee");

const loginEmployee = async (userData) => await api.post("/login", userData);

const loginAsUser = async (userid) => await api.get("/login-as/" + userid);

const resetImpersonate = async () => await api.get("/logout-as");

const logoutEmployee = async () => await api.post("/logout");

const getOrganogram = async () => await api.get("/organogram");

const employeeService = {
  loginEmployee,
  loginAsUser,
  resetImpersonate,
  logoutEmployee,
  getOrganogram,
};

export default employeeService;
